export default __webpack_public_path__ + "static/media/dictionary.0adcb38e.jpg";